import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import {Layout, Tabs} from '@phonectas/unifon-ui-kit';
import CustomerEvents from './CustomerEvents';
import SmsModule from './SmsModule';
import {StyledEventLayout, StyledTabsLayout} from './styled';
import {useSmallScreen} from 'common/hooks/useScreenSize';
import EnlargeIcon from 'common/components/icons/EnlargeIcon';
import ShrinkIcon from 'common/components/icons/ShrinkIcon';
import {StyledIconButton} from 'common/components/styled';


interface EventsTabProps {
	expEvent?: boolean;
	onShowExpand: () => void;
	onHideExpand: () => void;
	customerId?: string;
}

const EventsTab: React.FC<EventsTabProps> = ({expEvent, onShowExpand, onHideExpand, customerId}) => {
	const [t] = useTranslation();
	const [activeTab, setActiveTab] = useState('1');
	const isSmallScreen = useSmallScreen('(max-width: 1600px)');
	const primaryColor = '#001B74';
	// const isSmallScreenHeight = useSmallScreen('(max-height: 800px)');
	useEffect(() => {
		if (!isSmallScreen) {
			onHideExpand();
		}
	}, [isSmallScreen, onHideExpand]);

	return (
		<>
			<Layout fullWidth fullHeight style={{maxHeight: '40px'}}>
				<StyledTabsLayout direction="row" nowrap justifyContent="space-between" fullWidth>
					<Tabs
						active={activeTab}
						onChange={(value) => setActiveTab(String(value))}
						items={[
							{value: '1', label: t('Event log')},
							{value: '2', label: t('SMS')},
						]}
					/>
					{
						isSmallScreen && !expEvent && (
							<StyledIconButton $height={26}$width={26} onClick={onShowExpand}>
								<EnlargeIcon color={primaryColor} />
							</StyledIconButton>
						)
					}
					{
						expEvent && isSmallScreen && (
							<StyledIconButton $height={26}$width={26} onClick={onHideExpand}>
								<ShrinkIcon color={primaryColor} />
							</StyledIconButton>
						)
					}
				</StyledTabsLayout>
			</Layout>
			<StyledEventLayout activeTab={activeTab}>
				{activeTab === '1' && <CustomerEvents customerId={customerId ?? ''}/>}
				{activeTab === '2' && <SmsModule />}
			</StyledEventLayout>
		</>
	);
}

// Memo: the customer page re-renders on every tab switch, while the feed's props stay the same
export default React.memo(EventsTab);
